import gql from 'graphql-tag'

const FILE_UPLOAD_SAS = gql`
  query getSAS($permission: permission!, $filePath: String) {
    azureFileUploadSas(permission: $permission, filePath: $filePath)
  }
`

export const SAS_PERMISSION = {
  CREATE: 'CREATE',
  DELETE: 'DELETE',
}
export default FILE_UPLOAD_SAS
